<template>
  <v-container 
    v-if="layout === 'list'"
    grid wrap row no-gutters 
    class="mb-5 mt-5 symptoms-container" 
    :class="user.is_intervened ? 'is-intervened' : 'not-intervened'"
  >
    <v-col :cols="12" class="mb-4">
      <span v-if="user.last_report" color="dark">
        <i>
          Síntonas reportados hace {{ timeSince(user.last_reported_date) }}
        </i>
      </span>
    </v-col>
    <v-col :cols="6">
      <v-row class="symptoms-panel" v-for="(value, key) in answers" :key="key" align-center>
        <v-flex xs5 class="pl-5">
          <span class="symptom-label">
            {{ key.toUpperCase() }} 
          </span>
        </v-flex>
        <v-flex xs7 class="pr-5">
          <symptom-bar :value="value" />
        </v-flex>
      </v-row>
    </v-col>
      <v-col :cols="6">
          <div class="label">
              Comorbilidades
          </div>
          <div class="value mb-4">
             {{ user.comorbidities.map(e => e.name).join(", ")
              }}
          </div>
          <div class="label">
              Discapacidad
          </div>
          <div class="value">
             {{ getDisabledText(user.is_disabled) }}
          </div>
      </v-col>
  </v-container>
  <v-container 
    v-else-if="layout === 'profile'"
    grid wrap row no-gutters 
    class="symptoms-container" 
    color="background"

  >
    <v-col :cols="12" class="mb-4">
      <span v-if="user.last_report" color="dark">
        <i>
          Síntonas reportados hace {{ timeSince(user.last_reported_date) }}
        </i>
      </span>
    </v-col>
    <v-col :cols="12" class="white pa-5">  
      <v-row class="symptoms-panel" v-for="(value, key) in answers" :key="key" align-center>
        <v-flex xs3 class="pl-5">
          <span class="symptom-label">
            {{ key.toUpperCase() }} 
          </span>
        </v-flex>
        <v-flex xs6 class="pr-5">
          <symptom-bar :value="value" />
        </v-flex>
        <v-flex xs3 class="pl-5">
          <span class="severity-label">
            {{ getSeverityText(value) }} 
          </span>
        </v-flex>
      </v-row>
    </v-col>
    <v-col :cols="4" class="py-5 pr-2">
        <v-container class="white description-box">
          <div class="label">
              Comorbilidades
          </div>
          <p class="value mb-0" v-for="comorbidity in user.comorbidities" :key="comorbidity.id">
             {{ comorbidity.name }}
          </p>
      </v-container>
    </v-col>
    <v-col :cols="4" class="py-5 px-2">
      <v-container class="white description-box">
        <div class="label">
            Discapacidad Física
        </div>
        <div class="value">
           {{ getDisabledText(user.is_disabled)  }}
        </div>
      </v-container>
    </v-col>
    <v-col :cols="4" class="py-5 pl-2">
      <v-container class="white description-box">
        <div class="label">
            Peso aproximado
        </div>
        <div class="value mb-4">
           <strong>{{ user.weight }}</strong> {{ user.weight_type }}
        </div>
        <div class="label">
            Altura aproximada
        </div>
        <div class="value">
           <strong>{{ user.height }}</strong> {{ user.height_type }}
        </div>
      </v-container>
    </v-col>
  </v-container>
</template>

<script>

  import SymptomBar from './SymptomBar';

  export default {
    name: 'Symptoms',

    components: {
      SymptomBar
    },

    props: {
      user: {
        type: Object,
        required: true
      },
      layout: {
        type: String,
        default: 'list'
      }
    },

    computed: {
      answers() {
        const ordered = {};
        Object.keys(this.user.answers).sort().forEach((key) => {
          ordered[key] = this.user.answers[key];
        });
        return ordered;
      }
    },

    methods: {
      getSeverityText(value) {
        if (value === 1) return 'Poco'
        if (value === 2) return 'Bastante'
        if (value === 3) return 'Mucho'
        return 'Nada'
      },

      getDisabledText(value) {
        if (value === true) return "Sí";
        if (value === false) return 'No';
        return '-'
      }
    }
  }
</script>

<style lang="scss" scoped>
  
  .symptoms-container.is-intervened {
    background-color: #c3ecff;
  }

  .symptoms-container.not-intervened {
    background-color: #f5f8fc;
  }

  .symptom-label {
    color: #2a6680;
    font-weight: 600;
  }

  .label {
    color: #12729a;
    font-weight: 600;
    font-size: 1.125rem;
  }

  .value {
    color: #313b47;
    font-size: 1.075rem;
  }

  .description-box {
    height: 100%;
  }

  .severity-label {
    color: #12729a;
  }

</style>
